import en from "@/i18n/locales/en.json";
import ru from "@/i18n/locales/ru.json";

export const i18nResources = {
  en: { translation: en },
  ru: { translation: ru },
} as const;
